"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Theme = require("../Theme");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Button = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    className,
    variant = "primary",
    size = "md",
    color = "default",
    fullWidth = false,
    leadingIcon,
    trailingIcon,
    disabled,
    ...props
  } = _ref;
  const {
    primaryCtaColor,
    primaryCtaColorHover,
    theme: {
      button: buttonTheme
    }
  } = (0, _Theme.useThemeConfig)();
  const isPrimaryDefault = variant === "primary" && color === "default";
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    ref: ref,
    className: (0, _classnames.default)(buttonTheme.base, buttonTheme[variant][color].border, isPrimaryDefault && primaryCtaColor ? primaryCtaColor : buttonTheme[variant][color].bg, buttonTheme[variant][color].text, buttonTheme.size[size], {
      [buttonTheme.disabled]: disabled === true,
      [isPrimaryDefault && primaryCtaColorHover ? primaryCtaColorHover : buttonTheme[variant][color].hover]: disabled !== true,
      [buttonTheme[variant][color].focus]: disabled !== true,
      "w-full": fullWidth === true,
      [buttonTheme.centerAligned]: leadingIcon || trailingIcon
    }, className),
    disabled: disabled
  }, props), leadingIcon ? /*#__PURE__*/_react.default.cloneElement(leadingIcon, {
    "aria-hidden": true,
    className: "inline-block mr-4"
  }) : "", children, trailingIcon ? /*#__PURE__*/_react.default.cloneElement(trailingIcon, {
    "aria-hidden": true,
    className: "inline-block ml-4"
  }) : "");
});
exports.Button = Button;
Button.displayName = "Button";